import { BillingOffer, BillingOfferCode } from '../types/payment';

const MONTHLY_AMOUNT_CENTS = 10990;
const ANNUAL_RECURRING_INSTALLMENT_AMOUNT_CENTS = 8990;
const ANNUAL_RECURRING_CONTRACT_AMOUNT_CENTS = 107880;
const ANNUAL_UPFRONT_DISCOUNT_PERCENT = 20;
const ANNUAL_UPFRONT_AMOUNT_CENTS = Math.round(ANNUAL_RECURRING_CONTRACT_AMOUNT_CENTS * 0.8);

export const BILLING_OFFERS: Record<BillingOfferCode, BillingOffer> = {
  MONTHLY_RECURRING: {
    code: 'MONTHLY_RECURRING',
    label: 'Mensal recorrente',
    description: 'Cobranca automatica de R$ 109,90 por mes, com renovacao mensal automatica.',
    planName: 'Plano Mensal AuxiliaJud',
    amountCents: MONTHLY_AMOUNT_CENTS,
    originalAmountCents: MONTHLY_AMOUNT_CENTS,
    discountPercent: 0,
    billingCycle: 'MONTHLY',
    paymentMode: 'RECURRING',
    recurring: true
  },
  ANNUAL_RECURRING: {
    code: 'ANNUAL_RECURRING',
    label: 'Anual recorrente',
    description: 'Cobranca recorrente de 12x de R$ 89,90, sem lancar o valor total de uma vez no cartao. Cancelamento com taxa administrativa de 20% sobre o valor total do contrato.',
    planName: 'Plano Anual AuxiliaJud',
    amountCents: ANNUAL_RECURRING_INSTALLMENT_AMOUNT_CENTS,
    originalAmountCents: ANNUAL_RECURRING_CONTRACT_AMOUNT_CENTS,
    discountPercent: 0,
    billingCycle: 'YEARLY',
    paymentMode: 'RECURRING',
    recurring: true
  },
  ANNUAL_UPFRONT: {
    code: 'ANNUAL_UPFRONT',
    label: 'Anual a vista',
    description: 'Pagamento unico anual de R$ 863,04, cobrado de uma so vez.',
    planName: 'Plano Anual AuxiliaJud a vista',
    amountCents: ANNUAL_UPFRONT_AMOUNT_CENTS,
    originalAmountCents: ANNUAL_RECURRING_CONTRACT_AMOUNT_CENTS,
    discountPercent: ANNUAL_UPFRONT_DISCOUNT_PERCENT,
    billingCycle: 'YEARLY',
    paymentMode: 'ONE_TIME',
    recurring: false
  }
};

export const DEFAULT_BILLING_OFFER_CODE: BillingOfferCode = 'MONTHLY_RECURRING';

export const getBillingOffer = (code?: string | null): BillingOffer =>
  BILLING_OFFERS[(code as BillingOfferCode) || DEFAULT_BILLING_OFFER_CODE] || BILLING_OFFERS[DEFAULT_BILLING_OFFER_CODE];

export const formatCurrency = (amountCents: number) =>
  new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amountCents / 100);


